<template>
  <CollapsiblePanel
    id="settings-admin"
    :variant="['default', 'rounded', '30-12-paddings']"
    :label="$t('_web_tournament-menagament-operators', 'Tournament Operators')"
    class="prizes-title"
    :visible="isVisible"
  >
    <div class="prize-section-custom-wrapper">
      <div class="invite-admin">
        <Panel class="mb-5 d-flex flex-column">
          <div>
            <div v-if="canCreateTournament" class="pb-5">
              {{
                $t(
                  '_web_tournament-menagament-select-operator-subtitle',
                  'Please select operators who can menage this tournament, otherwise only administrators can do this (operators must be members of your organuzation account)'
                )
              }}
            </div>
            <div v-else>
              {{
                $t(
                  '_web_tournament-menagament-contact-menager',
                  'You are an operator of the tournament and you cannot edit the assigned operators, please address the owner of the event organization or a tournament manager'
                )
              }}
            </div>
          </div>

          <div class="list">
            <div
              v-if="
                usersList &&
                  usersList.admins &&
                  usersList.admins.filter(
                    admin => admin.role === 'Tournament_Operator'
                  ).length
              "
              class="col"
            >
              <ul class="list-group list-group-flush bg-transparent w-100">
                <li
                  v-for="user in usersList.admins.filter(
                    admin => admin.role === 'Tournament_Operator'
                  )"
                  :key="user.id"
                  class="border-0 bg-transparent row no-gutters d-flex justify-content-between align-items-center py-3 h-pr-3"
                >
                  <div
                    class="d-flex text-sm-left justify-content-between align-items-center w-100"
                  >
                    <ListItemAccount
                      :key="`admin_${user.id}`"
                      v-bind="{
                        accountId: user.id,
                        type: 'profile',
                        ref: user.id,
                        avatar: user.avatar,
                        class: 'text-sm',
                        name: $filters.displayName(user),
                      }"
                      class="py-3"
                    >
                    </ListItemAccount>
                    <div>
                      <HeraFormCheckbox v-model="admins" :val="user.id" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <template v-else>
              <HeraDummyList
                v-if="isLoading && !usersList.admins.length"
                icon-name="dummy/members"
                size="200"
                :header-text="
                  $t(
                    '_web_invite-admin_fetching_users',
                    `Fetching list of users`
                  )
                "
              />
            </template>
          </div>
        </Panel>
      </div>
    </div>
  </CollapsiblePanel>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import HeraFormCheckbox from '@/components/form/HeraFormCheckbox';
import HeraDummyList from '@/components/common/HeraDummyList';
import Panel from '@/components/atoms/Panel';
import listMixin from '@/mixins/paginatedLists';

import ListItemAccount from '@/components/common/ListItemAccount';
import CollapsiblePanel from '@/components/atoms/CollapsiblePanel';

export default {
  name: 'AdminSection',
  inject: ['$validator'],
  components: {
    CollapsiblePanel,
    HeraFormCheckbox,
    HeraDummyList,
    ListItemAccount,
    Panel,
  },
  mixins: [...listMixin],
  props: {
    adminsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      usersList: [],
      operators: [],
      userFilter: '',
    };
  },
  computed: {
    ...mapState('my', ['account']),
    ...mapGetters([
      'currentTournament',
      'isTournamentFieldDisabled',
      'hasAccessByPermission',
      'permissions',
    ]),
    isVisible() {
      return this.$route.hash === '#settings-admin';
    },
    canCreateTournament() {
      // TODO TH-8800
      // Hiding a button for a Regional Operator.
      // That has "administrative: all" permission but should not create tournaments (backend problem).
      return this.account.isOrganization
        ? !!this.permissions.createTournament
        : this.hasAccessByPermission('createTournament');
    },

    admins: {
      get() {
        return this.$lodash.get(this.currentTournament, 'admins');
      },
      set(operators) {
        this.updateCurrentTournament({
          required: operators,
          component: 'admins',
        });
      },
    },
  },

  created() {
    this.getAdmins();
  },
  methods: {
    ...mapActions(['fetchPlayers', 'errorNotify', 'fetchOrgs']),

    async getAdmins() {
      this.usersList = await this.fetchOrgs({
        organisationId: this.account._id,
      });
    },
  },
};
</script>

<style lang="scss">
.prize-section-custom-wrapper {
  padding: 13px !important;
  .place-column {
    width: 40px !important;
    flex-basis: 40px !important;
    flex-grow: 0 !important;
    box-sizing: content-box;
  }
}

.prizes-title span {
  font-size: $hr-heading-5 !important;
}

.prize-line span {
  font-size: $hr-text-large !important;
}

.prize-pool label {
  padding-bottom: 13px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.prize-pool input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.prize-pool input :focus {
  border: 2px solid $hr-bg-accent;
}

.prize-pool {
  padding-bottom: 10px;
}

.prize-line-label label {
  font-size: $hr-text-small !important;
  font-weight: 600;
  padding-bottom: 10px;
}

.prize-line-input input {
  background-color: $hr-bg-header !important;
  border: 2px solid transparent;
  margin-bottom: 15px;
}

.prize-line-input input :focus {
  border: 2px solid $hr-bg-accent;
}

.prizes-tooltip {
  margin-bottom: 27px;
  margin-right: 80px;
}

.prize-add-place {
  padding-top: 5px;
}

.prize-add-place span {
  font-size: $hr-text-small !important;
}
.account-link-name {
  font-size: 18px !important;
}
</style>
